@if ($isLoggedIn == undefined){

} @else if($isLoggedIn()) {
    <a (click)="logout()" class="full-width DTX_LOGOUT_BUTTON"> {{('Logout' | translateSignal)()}} </a>
} @else {
    <a (click)="showLogin()" class="full-width DTX_LOGIN_BUTTON"> {{('Login' | translateSignal)()}} </a>
}
